<template>
	<div class="speakers mh-700">
		<v-layout row wrap>
			<v-flex xs12>
				<ViewHeader
					src="https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fblue-cloud-h800.jpg?alt=media&token=63c4bf24-ccc2-4bb6-9420-ae001ca67ca0"
					title="Speakers"
				/>
			</v-flex>
		</v-layout>
		<v-container>
			<v-row>
      			<v-col sm="12">
					<div class="speaker-wrapper">
						<h3 class="pb-16">Plenary and Special Lecture Speakers</h3>
						<v-row>
      						<v-col sm="6" md="6" v-for="member in plenaryMembers"
									:key="member.name">
								<div	class="speaker-members">
									<img :src="member.photo" class="member-photo">
									<p class="speaker-item-first">{{ member.name }}</p>
									<p class="speaker-item-middle">
										{{ member.institution }}
									</p>
									<p class="speaker-item-last">
										<span v-if="member.city">{{ member.city }},</span>
										{{ member.country }}
									</p>
								</div>
							</v-col>
						</v-row>
					</div>
				</v-col>
			</v-row>
			<v-row>
      			<v-col sm="12">
					<div class="speaker-wrapper">
						<h3 class="pb-16">Speakers</h3>
						<div v-for="session in sessions" :key="session.number">
							<h4>Session {{ session.number }}</h4>
							<v-row>
								<v-col sm="6" md="4" v-for="member in session.speakers"
										:key="member.name">
									<div	class="speaker-members">
										<img :src="member.photo" class="member-photo">
										<p class="speaker-item-first">{{ member.name }}</p>
									</div>
								</v-col>
							</v-row>
						</div>						
					</div>
				</v-col>
			</v-row>			
		</v-container>
	</div>
</template>

<script>
import ViewHeader from '@/components/ViewHeader.vue';
export default {
	name: 'speakers',
	components: {
		ViewHeader
	},
	data: function() {
		return {
			subtitle: 'Speakers',
			plenaryMembers: [
				{
					name: 'Timothy Ryan, Plenary Speaker',
					institution: 'Weill College of Medicine',
					city: 'New York City, NY',
					country: 'USA',
					photo: 'https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fpeople%2FRyan-Timothy.jpg?alt=media&token=243b5230-65c6-4416-b759-5acee2fb1b66'
				},
				{
					name: 'Dorothy Koveal, Special Lecture',
					institution: 'Georgia Tech',
					city: 'Atlanta, GA',
					country: 'USA',
					photo: 'https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fpeople%2FKoveal-Dorothy.jpeg?alt=media&token=b7f783bf-4f29-429f-9360-4a56322d4d0c'
				},
			],
			sessions: [
				{
					number: 1,
					speakers: [
						{
							name: 'L. Felipe Barros',
							photo: 'https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fpeople%2FBarros-Felipe.jpg?alt=media&token=725acd35-dd96-43f8-8dec-bd3548b2a248'
						},
						{
							name: 'Carlos Diaz-Garcia',
							photo: 'https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fpeople%2FDiaz-Garcia-Carlos.jpg?alt=media&token=8059695c-07ec-4cf1-9fca-ecf565a103d0'
						},
						{
							name: 'Ewan McNay',
							photo: 'https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fpeople%2FMcKay-Ewan.jpg?alt=media&token=fa012df7-6782-4a73-9e3f-bc0abafa898a'
						}
					]
				},
				{
					number: 2,
					speakers: [
						{
							name: 'Douglas Rothman',
							photo: 'https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fpeople%2FRothman-Douglas.jpg?alt=media&token=81d157fd-aba9-42ad-8569-f6e0a9913cc8'
						},
						{
							name: 'Matthew Gentry',
							photo: 'https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fpeople%2FGentry-Matthew.jpg?alt=media&token=85fe001e-d3c3-4142-b054-032b47a50f63'
						},
						{
							name: 'Jordi Duran',
							photo: 'https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fpeople%2FDuran-Jordi.jpg?alt=media&token=e3dc34dc-9d32-4da6-a768-2a6a1248cce1'
						}
					]
				},
				{
					number: 3,
					speakers: [
						{
							name: 'Adi Kol',
							photo: 'https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fpeople%2FKol-Adi.jpg?alt=media&token=878d5403-00c5-4505-8abd-f9e82aa4407e'
						},
						{
							name: 'Robert Zorec',
							photo: 'https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fpeople%2FZorec-Robert.jpg?alt=media&token=9caf8fe8-901a-43b5-b364-6614ce72fd3e'
						},
						{
							name: 'Oliver Kann',
							photo: 'https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fpeople%2FKann-Oliver.jpg?alt=media&token=e1271491-5f23-43c6-aa92-c371ad330554'
						}
					]
				},
				{
					number: 4,
					speakers: [
						{
							name: 'Claudia Perez-Cruz',
							photo: 'https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fpeople%2FPerez-Cruz-Claudia.jpg?alt=media&token=94d43fa3-b714-4c74-8b18-bb423c7f57a0'
						},
						{
							name: 'Joseph Baur',
							photo: 'https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fpeople%2FBaur-Joseph.jpg?alt=media&token=2e74efee-1a93-4e69-a70d-df96c9fe8a27'
						},
						{
							name: 'Robert Pawlosky',
							photo: 'https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fpeople%2FPawlosky-Robert.jpg?alt=media&token=0e765bfd-a5d9-4d66-8512-8d3ff1022552'
						}
					],

				},
				{
					number: 5,
					speakers: [
						{
							name: 'Melanie Kaelberer',
							photo: 'https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fpeople%2FKaelberer-Melanie.jpg?alt=media&token=7787bd94-6590-4c9f-8392-0defeb6e3b67'
						},
						{
							name: 'Christine Olson',
							photo: 'https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fpeople%2FOlson-Christine.jpg?alt=media&token=fbdf26a0-2fc5-4ec4-b07e-5711bd7b3435'
						},
						{
							name: 'Shelly Buffington',
							photo: 'https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fpeople%2FBuffington-Shelly.jpg?alt=media&token=ceb09f1c-a6f5-48af-a8bc-61f0cc04fac9'
						},
					]
				},
				{
					number: 6,
					speakers: [
						{
							name: 'Berrak Ugur',
							photo: 'https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fpeople%2FUgur-Berrak.jpg?alt=media&token=802c2f25-006f-4cd2-bebe-7741699f9d85'
						},
						{
							name: 'Gero Miesenböck',
							photo: 'https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fpeople%2FMiesenb%C3%B6ck-Gero.jpg?alt=media&token=46670280-de03-4b2b-8273-c54b70baa025'
						},
						{
							name: 'Ignacio Fernandez Moncada',
							photo: 'https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fpeople%2FFernandez-Moncada-Ignacio.jpg?alt=media&token=15e1170d-1ff1-4442-a651-3b2bcd99d3b9'
						}
					]
				},
				{
					number: 7,
					speakers: [
						{
							name: 'Phil Lee',
							photo: 'https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fpeople%2FLee-Phil-cropped.jpg?alt=media&token=f5d1b4bd-562e-4f28-a0a9-8a199d1cda76'
						},
						{
							name: 'João M. N. Duarte',
							photo: 'https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fpeople%2FDuarte-Joao.jpg?alt=media&token=6f7cc387-20bc-4800-9c4e-7d533a928501'
						},
						{
							name: 'Wei Chen',
							photo: 'https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fpeople%2FChen-Wei-cropped.jpg?alt=media&token=846a9029-4f49-4689-865d-0128f3a002f2'
						}
					]
				},
				{
					number: 8,
					speakers: [
						{
							name: 'Bill Shuttleworth ',
							photo: 'https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fpeople%2FShuttleworth-William.jpg?alt=media&token=8004f34f-1a12-465d-81ac-a4576e9b93ac'
						},
						{
							name: 'Eszter Farkas',
							photo: 'https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fpeople%2FFarkas-Eszter.jpg?alt=media&token=808dd3a8-5c4f-4c5c-a177-f4cd1a878edc'
						},
						{
							name: 'Britta Lindquist',
							photo: 'https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fpeople%2FLindquist-Britta.jpg?alt=media&token=d5e2deee-f653-4400-8bd7-0a943edc8590'
						}
					]
				}
			]
		};
	},
	methods: {
		column1: list => {
			return list.filter((item, index) => {
				return index < Math.ceil(list.length / 2);
			});
		},
		column2: list => {
			return list.filter((item, index) => {
				return index >= Math.ceil(list.length / 2);
			});
		}
	}
};
</script>
<style scoped>
.speaker-wrapper {
	padding-top: 2rem;
	padding-bottom: 2rem;
}
.speaker-members {
	text-align: left;
}
.speaker-item-simple {
	font-weight: 600;
	margin-bottom: 6px !important;
	text-align: left;
}
.speaker-item-first {
	font-weight: 600;
	margin-bottom: 6px !important;
	margin-top: 1rem;
}
.speaker-item-middle {
	margin-bottom: 6px !important;
}
.speaker-item-last {
	margin-bottom: 2.5rem;
}
.speaker-item-first,
.speaker-item-middle,
.speaker-item-last {
	text-align: center;
}
.member-photo {
	display: block;
  	margin-left: auto;
  	margin-right: auto;
  	width: 95px;
	height: 130px;
}
</style>